import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Navbar from '../components/landing/Navbar'
import Footer from '../components/landing/Footer'
import '../assets/styles/landing.css'

export default function LandingLayout() {
  const location = useLocation()

  useEffect(() => {
    if (!location.hash && !location.state?.scrollTo) {
      window.scrollTo(0, 0)
    }
  }, [location.pathname])

  return (
    <div className="font-inter text-gray-900 bg-white min-h-screen">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
